export default [{
    "id": 1,
    "first_name": "Lovell",
    "last_name": "Cloke",
    "city": "Tampa",
    "state": "FL",
    "userImg": "http://dummyimage.com/151x250.jpg/ff4444/ffffff",
    "following": true
  }, {
    "id": 2,
    "first_name": "Maura",
    "last_name": "Gawthrop",
    "city": "Miami",
    "state": "FL",
    "userImg": "http://dummyimage.com/198x125.bmp/ff4444/ffffff",
    "following": false
  }, {
    "id": 3,
    "first_name": "Dodie",
    "last_name": "Oldnall",
    "city": "Torrance",
    "state": "CA",
    "userImg": "http://dummyimage.com/232x175.png/dddddd/000000",
    "following": false
  }, {
    "id": 4,
    "first_name": "Gualterio",
    "last_name": "Dransfield",
    "city": "Marietta",
    "state": "GA",
    "userImg": "http://dummyimage.com/172x222.jpg/5fa2dd/ffffff"
  }, {
    "id": 5,
    "first_name": "Othilia",
    "last_name": "Meco",
    "city": "Seattle",
    "state": "WA",
    "userImg": "http://dummyimage.com/193x157.png/5fa2dd/ffffff",
    "following": true
  }, {
    "id": 6,
    "first_name": "Roseanna",
    "last_name": "Beri",
    "city": "Louisville",
    "state": "KY",
    "userImg": "http://dummyimage.com/142x183.png/5fa2dd/ffffff",
    "following": false
  }, {
    "id": 7,
    "first_name": "Janie",
    "last_name": "d'Escoffier",
    "city": "San Francisco",
    "state": "CA",
    "userImg": "http://dummyimage.com/125x166.png/ff4444/ffffff",
    "following": true
  }, {
    "id": 8,
    "first_name": "Jens",
    "last_name": "Dartnell",
    "city": "Columbia",
    "state": "SC",
    "userImg": "http://dummyimage.com/143x227.jpg/dddddd/000000",
    "following": true
  }, {
    "id": 9,
    "first_name": "Skip",
    "last_name": "Patten",
    "city": "Denver",
    "state": "CO",
    "userImg": "http://dummyimage.com/229x214.bmp/dddddd/000000",
    "following": true
  }, {
    "id": 10,
    "first_name": "Edd",
    "last_name": "Febvre",
    "city": "San Jose",
    "state": "CA",
    "userImg": "http://dummyimage.com/159x223.jpg/ff4444/ffffff",
    "following": true
  }, {
    "id": 11,
    "first_name": "Pegeen",
    "last_name": "Leppington",
    "city": "Paterson",
    "state": "NJ",
    "userImg": "http://dummyimage.com/169x242.png/5fa2dd/ffffff",
    "following": true
  }, {
    "id": 12,
    "first_name": "Querida",
    "last_name": "Brabbins",
    "city": "Columbia",
    "state": "SC",
    "userImg": "http://dummyimage.com/175x183.bmp/cc0000/ffffff",
    "following": true
  }, {
    "id": 13,
    "first_name": "Marcelline",
    "last_name": "McKerron",
    "city": "Sacramento",
    "state": "CA",
    "userImg": "http://dummyimage.com/132x244.bmp/cc0000/ffffff"
  }, {
    "id": 14,
    "first_name": "Rudolph",
    "last_name": "Oxburgh",
    "city": "Cincinnati",
    "state": "OH",
    "userImg": "http://dummyimage.com/155x159.jpg/cc0000/ffffff",
    "following": true
  }, {
    "id": 15,
    "first_name": "Ansley",
    "last_name": "Kelland",
    "city": "Washington",
    "state": "DC",
    "userImg": "http://dummyimage.com/165x158.png/dddddd/000000",
    "following": true
  }]